import { render, staticRenderFns } from "./TaxiPrognoseLayer.vue?vue&type=template&id=4fb4c98a&"
import script from "./TaxiPrognoseLayer.vue?vue&type=script&lang=js&"
export * from "./TaxiPrognoseLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports